module.exports = __webpack_public_path__ + "static/media/icon.f79a6de3.png";